module.exports = __webpack_public_path__ + "img/company2.d742f677.jpg";